// external
import React from "react";
import { Outlet } from "react-router-dom";

// components
import FaoBuilderFeedback from "./fao-builder-feedback";

function FaoBuilderLayout() {
  return (
    <div>
      <div className="absolute right-9 top-24">
        <FaoBuilderFeedback />
      </div>
      <Outlet />
    </div>
  );
}

export default FaoBuilderLayout;
